@if (showLoader) {
  <div class="loader-content">
    <div class="loader"></div>
    <p *ngIf="message" class="loader-message">{{ message }}</p>
  </div>
}
